import { render, staticRenderFns } from "./Popularity.vue?vue&type=template&id=79f21e8b&"
import script from "./Popularity.vue?vue&type=script&lang=js&"
export * from "./Popularity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports